import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { SubVertical } from "../../utility/modals";

@Injectable({ providedIn: 'root' })
export class SubverticalService {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common/subvertical';

  postsubvertical(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/createSubvertical`, payload);  // Subvertical Add
  }
  modifysubvertical(payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseURL}/updatesubvertical`, payload);  // Subvertical update
  }
  getall_subvertical(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/subverticaldata`);
  }
  get_vertical(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/verticaldata`);
  }
  get_subvertical_view(subverticalid: number): Observable<SubVertical> {
    return this.httpClient.get<SubVertical>(`${this.baseURL}/findsubvertical/${subverticalid}`);
  }
  subverticalDataExcel() {
    return this.httpClient.get(`${this.baseURL}/subverticalDataExcel`, { responseType: 'blob' });
  }
  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
  }
} 